import React, { Component } from 'react';
import Button from './Shared/Button';
import FormatText from '../Utils/TextFormatter';

export default class Intro extends Component {

    state = {
        serial: '',
    }

    componentDidMount(){
        const chars = "0123456789";
        let serial = "";

        for(let i=0;i<5;i++){
            serial += chars.charAt(Math.floor(chars.length * Math.random()));
        }

        this.setState({serial:serial});
    }

	render() {
		const {style, title, description, followingScreen, altButtonTitle} = this.props;
        const padding = 40;

        const buttonText = (altButtonTitle !== "" && altButtonTitle !== undefined) ? altButtonTitle : "התחלה";
        
        return <div style={style}>
            {/* <span style={{
                    position: "absolute",
                    top: -40,
                    right: 0,
                    width: "100%",
                    textAlign: "center",
                    fontSize: 16,
                }}>{'מס. סידורי ― ' + this.state.serial}</span> */}
            <div id="intro_container" style={{
                position: "absolute",
                bottom: 0,
                height: 400,
                right: padding,
                left: padding,
                textAlign: "right",
            }}>
                
                <h1>{title}</h1>
                <div className="separation-bar"/>
                <div className= 'paragraph'>{FormatText(global.isMale,description, 12)}</div>
            </div>
                <div style={{
                    position:"absolute",
                    bottom:padding,
                    width:"100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <Button text={buttonText} isActive={true} onClick={() => {
                        global.nextStage(followingScreen)
                    }}/>
                </div>
	  	</div>
	}
}



// WEBPACK FOOTER //
// ./src/Comp/Intro.js